import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';
import { OrderedSet } from 'immutable';

import { FormulaEntity } from './formula.entity';

interface IFormulaItemEntity {
	id: number;
	label: string;
	isActive: boolean;
	isShared: boolean;
	description: string;
	dataType: string;
	tags: OrderedSet<AppTagItemEntity>;
	updateDate: string | Date;
	updatedBy: string;
	updatedByAvatar: AvatarEntity | undefined;
	isOwner: boolean;
	formula: FormulaEntity;
}

const entityDefaults: IFormulaItemEntity = {
	id: -1,
	label: '',
	description: '',
	dataType: '',
	tags: OrderedSet(),
	updateDate: '',
	updatedBy: '',
	isOwner: false,
	isActive: false,
	updatedByAvatar: undefined,
	isShared: false,
	formula: FormulaEntity.build(),
};

export class FormulaItemEntity implements IFormulaItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public description = entityDefaults.description;
	public label = entityDefaults.label;
	public tags = entityDefaults.tags;
	public updateDate = entityDefaults.updateDate;
	public updatedBy = entityDefaults.updatedBy;
	public isOwner = entityDefaults.isOwner;
	public isActive = entityDefaults.isActive;
	public updatedByAvatar = entityDefaults.updatedByAvatar;
	public isShared = entityDefaults.isShared;
	public dataType = entityDefaults.dataType;
	public formula = entityDefaults.formula;

	public static build(
		params: Partial<IFormulaItemEntity> = {}
	): FormulaItemEntity {
		const entity = new FormulaItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.description = params.description ?? entityDefaults.description;
		entity.label = params.label ?? entityDefaults.label;
		entity.tags = params.tags ?? entityDefaults.tags;
		entity.updateDate = params.updateDate ?? entityDefaults.updateDate;
		entity.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;
		entity.isOwner = params.isOwner ?? entityDefaults.isOwner;
		entity.isActive = params.isActive ?? entityDefaults.isActive;
		entity.isShared = params.isShared ?? entityDefaults.isShared;
		entity.dataType = params.dataType ?? entityDefaults.dataType;
		entity.formula = params.formula ?? entityDefaults.formula;
		if (params.updatedBy) {
			entity.updatedByAvatar = AvatarEntity.build(params.updatedBy);
		}
		return entity;
	}
}
